import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShowResponseType } from "~/features/business-section";

type RequestDataType = {
  businessSectionId: string;
};

const request = async ({
  businessSectionId,
}: RequestDataType): Promise<ApiManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShowResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShowResponseType>(
      `/api/managers/business_sections/${businessSectionId}/latest_business_section_last_week_post_ai_summary`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShow =
  ({
    businessSectionId,
    config = {},
  }: PropsType): UseQueryResult<ApiManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShowResponseType> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "ApisManagersBusinessSectionsLatestBusinessSectionLastWeekPostAiSummariesShow",
        businessSectionId,
      ],
      queryFn: () => request({ businessSectionId }),
      cacheTime: 0,
    });
  };
